
import SidebarRight from "../../../assets/duotone/SidebarRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SidebarRightIcon({ className, dataTestid = "SidebarRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SidebarRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
